module.exports = __webpack_public_path__ + "static/media/starReview.69953bf0.gif";